import React from "react"
import { isQaEnv, setApiEnv } from "../../helpers/apiEnv"

/**
 * Banner MUY llamativo que avisa cuando el portal está mostrando datos de QA.
 * Se renderiza arriba de todo, en cualquier pantalla. Solo aparece en modo QA.
 */
const QaBanner = () => {
  if (!isQaEnv()) return null

  const salir = () => {
    setApiEnv("prod")
    window.location.reload()
  }

  return (
    <div
      style={{
        width: "100%",
        background:
          "repeating-linear-gradient(45deg,#b91c1c,#b91c1c 16px,#dc2626 16px,#dc2626 32px)",
        color: "#fff",
        fontWeight: 800,
        fontSize: "0.85rem",
        letterSpacing: 0.4,
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        position: "sticky",
        top: 0,
        zIndex: 3000,
        boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        textShadow: "0 1px 2px rgba(0,0,0,0.35)",
      }}
    >
      <i className="mdi mdi-flask-outline" style={{ fontSize: 20 }} />
      <span>
        MODO QA · Estás viendo datos de la base de PRUEBAS — NO es producción
      </span>
      <button
        type="button"
        onClick={salir}
        style={{
          border: "1.5px solid rgba(255,255,255,0.9)",
          background: "rgba(255,255,255,0.18)",
          color: "#fff",
          borderRadius: 6,
          padding: "3px 12px",
          fontSize: "0.78rem",
          fontWeight: 700,
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <i className="mdi mdi-exit-to-app me-1" />Salir de QA
      </button>
    </div>
  )
}

export default QaBanner
